import { useEffect } from 'react';
import { noop } from 'lodash-es';
import { useStore, useStoreActions } from '~/contexts';
import { useIoContext } from '~/providers/IoContext';
import { selectors } from '~/store/state-selectors';
import { useFeatureFlags } from './useFeatureFlags';
import { useRegisterMobileNotification } from './useRegisterMobileNotification';
const isFullSignIn = (state)=>{
    var _state_claims;
    return state.authToken != null && !selectors.isViewMode(state) && selectors.impersonatingAs(state) == null && !((_state_claims = state.claims) === null || _state_claims === void 0 ? void 0 : _state_claims.adHocLinkSession);
};
const signedInUserId = (state)=>{
    var _ref;
    var _state_userInfo;
    return (_ref = (_state_userInfo = state.userInfo) === null || _state_userInfo === void 0 ? void 0 : _state_userInfo.id()) !== null && _ref !== void 0 ? _ref : null;
};
const signedInEmail = (state)=>{
    var _ref;
    var _state_claims;
    return (_ref = (_state_claims = state.claims) === null || _state_claims === void 0 ? void 0 : _state_claims.email) !== null && _ref !== void 0 ? _ref : null;
};
const phonePushToken = (state)=>state.nativePushTokenInfo;
export const useNativePush = ()=>{
    const { native, getNow } = useIoContext();
    const { NATIVE_PUSH } = useFeatureFlags();
    const isSignedInFully = useStore(isFullSignIn);
    const userId = useStore(signedInUserId);
    const email = useStore(signedInEmail);
    const pushToken = useStore(phonePushToken);
    const pushEnabled = !!NATIVE_PUSH && native.push.isAvailable && isSignedInFully;
    const { registerMobileNotification } = useRegisterMobileNotification();
    const { setNativePushTokenInfo } = useStoreActions();
    useEffect(()=>{
        if (pushEnabled && userId != null && email != null && pushToken != null) {
            native.pushRegistration.remember({
                pushToken,
                userId,
                email
            }).catch(noop);
        }
    }, [
        pushEnabled,
        userId,
        email,
        pushToken
    ]);
    useEffect(()=>{
        if (pushEnabled) {
            const { push } = native;
            let lastPostedToken = null;
            const onToken = (info)=>{
                setNativePushTokenInfo(info);
                if (info.token === lastPostedToken) {
                    return;
                }
                lastPostedToken = info.token;
                const registeredAt = getNow();
                registerMobileNotification(info, {
                    onSuccess: ()=>{
                        native.pushRemovalOutbox.clearForToken(info.token, registeredAt).catch(noop);
                    },
                    onError: ()=>{
                        lastPostedToken = null;
                    }
                });
            };
            const removeTokenListenerPromise = push.registerTokenListener(onToken);
            void removeTokenListenerPromise.then(()=>push.requestPermissionAndRegister()).catch(()=>undefined);
            const removeResumeListener = native.lifecycle.registerResumeListener(()=>{
                void push.requestPermissionAndRegister().catch(()=>undefined);
            });
            return ()=>{
                void removeTokenListenerPromise.then((removeListener)=>removeListener()).catch(()=>undefined);
                removeResumeListener();
            };
        }
        return undefined;
    }, [
        pushEnabled,
        registerMobileNotification
    ]);
};
